module.exports = __webpack_public_path__ + "static/media/logo-letter-1.f2e3da5b.png";